import React, { createContext, useContext, useMemo } from 'react';
import usePublicBrand from '../hooks/usePublicBrand';
import { createPublicBrandTheme, resolvePublicBrand } from '../utils/publicBrand';

const PublicBrandContext = createContext(null);

export function usePublicBrandContext() {
  return useContext(PublicBrandContext);
}

/**
 * Loads brand (from API or embedded payload) and shares it with all public children.
 */
export function PublicBrandProvider({ children, embeddedBrand }) {
  const { brand, loading } = usePublicBrand(embeddedBrand);
  const theme = useMemo(() => createPublicBrandTheme(brand), [brand]);
  const value = useMemo(
    () => ({
      brand,
      resolved: resolvePublicBrand(brand),
      theme,
      loading,
    }),
    [brand, theme, loading]
  );

  return <PublicBrandContext.Provider value={value}>{children}</PublicBrandContext.Provider>;
}
